import Contact12 from './Contact12'
export default Contact12
